import AboutFinance from './AboutFinance.vue'

export default AboutFinance
